<template>
  <div class="form-item">
    <label>{{ label }}{{label ? ':' : ''}}</label>
    <div class="form_">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'formItem',
  props: {
    label: null,
    labelWidth: {
      type: [String, Number],
      default: 'auto'
    }
  },
  computed: {
    labelStyle() {
      return {
        width: this.labelWidth === 'auto' ? 'auto' : this.labelWidth + 'px'
      }
    }
  }
}
</script>

<style lang="sass">
@import "styles/index"
</style>
